import { fetch } from '@/utils/fetch';

export const getHistory = (params) => {
  return fetch({
    url: '/api/my/entity/select',
    method: 'POST',
    data: params,
  });
};

export const deleteHistory = (params) => {
  return fetch({
    url: '/api/my/entity/delete',
    method: 'POST',
    data: params,
  });
};

export const addHistory = (params) => {
  return fetch({
    url: '/api/my/entity/save',
    method: 'POST',
    data: params,
  });
};
